<template>
  <div class="admin-login-page">
    <div class="login-container">
      <div class="left-img">
        <img src="@/assets/admin/bg.png" />
      </div>
      <div class="right-con">
        <div class="right-t">欢迎登录科学观测网</div>
        <div class="r-form">
          <el-form
            ref="form"
            :model="loginForm"
            label-width="80px"
            label-position="top"
            :rules="rules"
          >
            <el-form-item label="用户名" prop="userName">
              <el-input
                v-model="loginForm.userName"
                type="text"
                auto-complete="off"
                placeholder="请输入用户名"
              >
                <i
                  class="el-icon-user"
                  slot="prefix"
                  style="font-size: 18px"
                ></i>
              </el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input
                v-model="loginForm.password"
                placeholder="请输入密码"
                type="password"
              >
                <i
                  class="el-icon-info"
                  slot="prefix"
                  style="font-size: 18px"
                ></i>
              </el-input>
            </el-form-item>
          </el-form>
          <div class="form-btn">
            <el-button
              type="primary"
              :loading="loading"
              round
              @click="loginHandle"
              >登录</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loginForm: {
        userName: "",
        password: "",
      },
      loading: false,
      rules: {
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  methods: {
    loginHandle() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return false;

        this.loading = true;

        try {
          await this.$store.dispatch("Login", {
            userName: this.loginForm.userName,
            password: this.loginForm.password,
          });

          this.$message.success("登录成功");

          await this.$store.dispatch("GetInfo");

          this.$router.push("/admin");
        } catch (error) {
          console.error("后台登录异常:", error);
          this.$message.error(error.message || "登录失败，请检查账号密码");
        } finally {
          // 确保无论成功失败都关闭 loading
          this.loading = false;
        }
      });
    },
  },
};
</script>
<style lang="less" >
.admin-login-page {
  width: 100vw;
  height: 100vh;
  background-image: linear-gradient(
    to right,
    rgba(67, 116, 248) 0%,
    rgb(152, 215, 212) 100%
  );
  display: flex;
  justify-content: center;
  align-items: center;
  .login-container {
    width: 50vw;
    min-width: 1200px;
    height: 600px;
    background: #fff;
    border-radius: 50px;
    border-top-right-radius: 10px;
    border-bottom-left-radius: 10px;
    display: flex;
    overflow: hidden;
    .left-img {
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .right-con {
      width: 50%;
      background: rgb(237, 242, 250);
      .right-t {
        padding-top: 100px;
        text-align: center;
        font-size: 24px;
        color: #333;
        font-weight: 600;
      }
      .r-form {
        padding-top: 60px;
        width: 50%;
        margin: auto;
        .el-input {
          height: 50px !important;
          line-height: 50px;
          display: flex;
          align-items: center;
        }
        .el-input__prefix {
          left: 10px;
          top: 1px;
        }
        .el-input__inner {
          height: 60px !important;
          line-height: 60px;
          text-indent: 5px;
        }
      }
    }
    .form-btn {
      margin-top: 90px;
      width: 100%;
      .el-button {
        width: 100%;
        letter-spacing: 2px;
        font-size: 20px;
      }
    }
  }
}
</style>